import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, useLocation, withRouter } from 'react-router-dom'
import { METABASE_URL } from '../../Constants'
import { saveUrlToLocalStorage } from '../../utility/Utils'

const SsoMetabaseRedirect = ({ metabaseAuthenticationToken }) => {
  const location = useLocation()
  const history = useHistory()

  const returnTo =
    new URLSearchParams(location.search).get('return_to') ||
    METABASE_URL ||
    'https://reporting.staging.getmarketfuel.io'

  useEffect(() => {
    // redirect to metabase if auth token exists, otherwise redirect to login
    if (metabaseAuthenticationToken) {
      const redirectUrl = `${returnTo}/auth/sso?jwt=${metabaseAuthenticationToken}`
      window.location.href = redirectUrl
    } else {
      saveUrlToLocalStorage(`/sso/external/metabase?return_to=${returnTo}`)
      history.push('/login')
    }
  }, [metabaseAuthenticationToken, history, returnTo])

  return null
}

const mapStateToProps = state => ({
  metabaseAuthenticationToken: state.admins.current_admin.metabase_authentication_token
})

export default withRouter(connect(mapStateToProps)(SsoMetabaseRedirect))
